import { useEffect, useState } from "react";

const Countdown = ({
  seconds,
  onTimerEnd,
}: {
  seconds: number;
  onTimerEnd?: () => void;
}) => {
  const [counter, setCounter] = useState(seconds);
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const timer =
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [counter]);

  useEffect(() => {
    if (!complete && counter === 0 && onTimerEnd) {
      setComplete(true);
      onTimerEnd();
    }
  }, [complete, counter, onTimerEnd]);

  return <>{counter}</>;
};

export default Countdown;
